<div synGrid>

    <div synGridCell [size]="3" *ngIf="message">
        <div class="syn-grid__cell__subtitle">
            {{ message }}
        </div>
    </div>

    <div fxLayout="column" synGridCell [size]="4">
        <syn-message-box *ngIf="editable" [noMarginTop]="true" class="organization-tree-empty-message syn--padding-bottom" color="info" leftIcon="information-outline">
            Pour structurer au mieux les metadatas d'un élément, nous vous conseillons de formater la clé de la façon suivante:
            <code>fonction/application/id</code> (exemple "monitoring/glpi/hostid").
            <br/>
            Merci également de référencer <a href="https://claranet-fr.atlassian.net/wiki/x/dIPQD">ici</a> les metadatas que vous utilisez pour vos integrations.
        </syn-message-box>
        <mat-card appearance="outlined" class="syn-card" *ngIf="displayInCard; else tableContent">
            <ng-container *ngTemplateOutlet="tableContent"></ng-container>
        </mat-card>

        <ng-template #tableContent>
            <div class="filter">
                <mat-form-field [style.fontSize.px]="12" appearance="outline">
                    <mat-label>Filtrer</mat-label>
                    <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filtrer">
                    <button mat-icon-button
                            matSuffix
                            (click)="applyFilter('', filter)" >
                        <mat-icon svgIcon="close"></mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <mat-table #table [dataSource]="dataSource" class="magicbox-scroll" matSort>
                    <!-- key -->
                    <ng-container matColumnDef="key">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Clé </mat-header-cell>
                        <mat-cell *matCellDef="let row"> {{row.key}} </mat-cell>
                    </ng-container>

                    <!-- value -->
                    <ng-container matColumnDef="value">
                        <mat-header-cell *matHeaderCellDef mat-sort-header > Valeur </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <span *ngIf="editingMetadataKey !== row.key; else editingCell" class="magicbox-value-cell">{{row.value}}</span>
                            <ng-template #editingCell>
                                <mat-form-field class="magicbox-field" appearance="outline">
                                    <textarea matInput [(ngModel)]="editingMetadataValue" ></textarea>
                                    <mat-hint *ngIf="!editingMetadataValue">Valeur requise</mat-hint>
                                </mat-form-field>
                            </ng-template>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" class="magicbox-row" ></mat-row>

                    <!-- action buttons -->
                    <ng-container matColumnDef="action_buttons">
                        <mat-header-cell *matHeaderCellDef class="magicbox-button-cell"></mat-header-cell>
                        <mat-cell *matCellDef="let row" class="magicbox-button-cell">
                            <mat-icon class="magicbox-button" (click)="editMetadata(row.key)" *ngIf="editingMetadataKey !== row.key && editable" svgIcon="pencil-outline"></mat-icon>
                            <mat-icon class="magicbox-button" (click)="deleteMetadata(row.key)" *ngIf="editingMetadataKey !== row.key  && editable" svgIcon="delete-outline"></mat-icon>
                            <mat-icon class="magicbox-button visible" (click)="updateMetadata(row.key)" *ngIf="editingMetadataKey === row.key && editingMetadataValue" svgIcon="check"></mat-icon>
                            <mat-icon class="magicbox-button visible" (click)="cancelEditMetadata()" *ngIf="editingMetadataKey === row.key" svgIcon="close"></mat-icon>
                        </mat-cell>
                    </ng-container>
            </mat-table>

            <div *ngIf="editable" synGridCell [size]="4">
                <form [formGroup]="magicboxForm" #formDirective="ngForm" (ngSubmit)="addMetadata(formDirective)">
                    <div class="form-fields-container">
                        <mat-form-field class="magicbox-field" appearance="outline">
                            <mat-label>Clé</mat-label>
                            <input matInput placeholder="Clé" [matAutocomplete]="auto" formControlName="key">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let metadata of metadataKeys$ | async" [value]="metadata.name">
                                  <span>{{metadata.name}}</span> |
                                  <small>{{metadata.count}} {{metadata.count === 1 ? 'utilisation' : 'utilisations'}}</small>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="magicboxForm.get('key').hasError('keyNotUnique')">
                                La clé existe déjà
                            </mat-error>
                            <mat-error *ngIf="magicboxForm.get('key').hasError('pattern') || magicboxForm.get('key').hasError('required')">
                                Les caractères autorisés sont a-z, 0-9, le / et le trait d'union.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="magicbox-field" appearance="outline">
                            <mat-label>Value</mat-label>
                            <textarea matInput placeholder="Valeur" formControlName="value"></textarea>
                        </mat-form-field>

                        <div class="add-button-container">
                            <button mat-raised-button
                                color="accent"
                                type="submit"
                                [disabled]="magicboxForm.invalid"
                                name="action">
                                Ajouter
                            </button>
                        </div>
                    </div>
                </form>
            </div>

        </ng-template>
    </div>
</div>
